/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useMemo, useReducer, useState } from "react";
import {
  ChevronUpIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";
import { MicrophoneIcon, StopIcon } from "@heroicons/react/24/solid";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import {
  useManageIPMSContext,
} from "./ManageIPMSContex";
import {
  QuarterDates,
  QuaterDate,
} from "../../model/ipmsmodel";
import {
  GetEmployeeGoalDataResponse,
  Quarters,
  Goals
} from "./newipmsmodel";
import { useLocation, useNavigate } from "react-router-dom";
// import Select from "react-select";
import moment from "moment";
import {
  convertSaveUpdateGoalsToPayload,
  getQuarterRanges,
} from "./convertionHealper";
import GoalsAccordianPage from "./Accordion";
import { GoalsAssessmentFlagStatusEnumTextCap, GoalsFlagStatusEnum, GoalsFlagStatusEnumTextCap, USERROLEENUM } from "./constant";
import { getCookieData, getUserIdTokenForIPMSEmployid } from "../../helper/api";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useAuth } from "../../context/LoginContext";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import SingleSelect from "../../components/SingleSelect";
import { ConfirmRejectToast } from "./goalsAssessment";

type QuartersAction =
  | { type: "SET_QUARTERS"; payload: Quarters }
  | { type: "ADD_GOAL"; quarter: string; goal: Goals }
  | { type: "CLONE_GOAL"; quarter: string; goal: Goals[] }
  | { type: "REMOVE_GOAL"; quarter: string; index: number }
  | {
    type: "UPDATE_GOAL";
    quarter: string;
    index: number;
    field: keyof Goals;
    value: string | number;
  }
  | {
    type: "UPDATE_APPROVER"; // No field here
    quarter: string;
    index: number;
    field: keyof Goals; // Ensure field is defined
    value: string;
  };

const quartersReducer = (
  state: Quarters,
  action: QuartersAction
): Quarters => {
  switch (action.type) {
    case "SET_QUARTERS":
      return action.payload;
    case "ADD_GOAL": {
      const currentQuarterAdd = state[action.quarter] || { kra: [], soft: [], org: [], status: "DRAFT" };
      return {
        ...state,
        [action.quarter]: {
          ...currentQuarterAdd,
          kra: [...(currentQuarterAdd.kra || []), action.goal],
        },
      };
    }
    case "CLONE_GOAL": {
      const currentQuarterClone = state[action.quarter] || { kra: [], soft: [], org: [], status: "DRAFT" };
      return {
        ...state,
        [action.quarter]: {
          ...currentQuarterClone,
          kra: action.goal,
        },
      };
    }
    case "REMOVE_GOAL": {
      const currentQuarterRemove = state[action.quarter];
      if (!currentQuarterRemove) return state;
      const updatedGoals = (currentQuarterRemove.kra || []).filter(
        (_, i) => i !== action.index
      );
      return {
        ...state,
        [action.quarter]: {
          ...currentQuarterRemove,
          kra: updatedGoals,
        },
      };
    }
    case "UPDATE_GOAL": {
      const currentQuarterUpdate = state[action.quarter];
      if (!currentQuarterUpdate) return state;
      const updatedGoals = (currentQuarterUpdate.kra || []).map((goal, i) =>
        i === action.index
          ? {
            ...goal,
            changesType: goal.changesType === "new" ? "new" : "update",
            [action.field]: action.value,
          }
          : goal
      );
      return {
        ...state,
        [action.quarter]: {
          ...currentQuarterUpdate,
          kra: updatedGoals,
        },
      };
    }
    case "UPDATE_APPROVER": {
      const currentQuarterApprover = state[action.quarter];
      if (!currentQuarterApprover) return state;
      // Note: Approver logic might need adaptation for new model if approver isn't on goal
      return state;
    }
    default:
      return state;
  }
};

export interface ApproverInterface {
  full_name: string;
  employee_id: number;
}

interface AccordionItemProps {
  title: string;
  content: React.ReactNode;
  icon?: React.ReactNode;
  isOpen?: boolean;
  dateRange: QuaterDate;
  copyGoalsHandler: (quarter: string, currentQuarter: string) => void;
  copyQuarterName: string;
  mainIndexId: number;
  approverNameList: ApproverInterface[];
  copyButtonShowHide: boolean;
  handleApproverInputChange?: (
    quarter: string,
    index: number,
    field: string,
    value: string
  ) => void;
  approverValue?: string;
  approverError?: string;
  formRole: string;
}

const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  content,
  isOpen = true,
  dateRange,
  copyQuarterName,
  copyGoalsHandler,
  copyButtonShowHide = true,
  // mainIndexId,
  // approverNameList,
  // handleApproverInputChange,
  // approverValue,
  // approverError,
  // formRole
}) => {
  const [open, setOpen] = useState(isOpen);
  // console.log(title, copyQuarterName, mainIndexId)
  const toggleAccordion = () => setOpen(!open);
  return (
    <div className="mb-2">
      <h2>
        <button
          type="button"
          className={`flex items-center justify-between w-full p-5 text-gray-800 font-semibold border  border-gray-200  ${open ? "rounded-0" : "rounded-0"
            } bg-green-100 hover:bg-green-100  gap-3 focus:ring-0 `}
          onClick={toggleAccordion}
          aria-expanded={open}
          aria-controls="accordion-content"
        >
          <span className="flex items-center">
            {/* {icon} */}
            {title} - Goals
          </span>
          <span className="px-10">
            Goal Timeline should be between &#34;{" "}
            {dateRange &&
              dateRange.start &&
              moment(dateRange.start).format("DD-MMM-YYYY")}
            &#34; & &#34;
            {dateRange &&
              dateRange.end &&
              moment(dateRange.end).format("DD-MMM-YYYY")}
            &#34;
          </span>

          <ChevronUpIcon
            className={`w-5 h-5 ${open ? "rotate-180" : ""} shrink-0`}
          />
        </button>
      </h2>
      {open && (
        <div
          id="accordion-content"
          className="p-5 border border-gray-200 border-t-0 dark:border-gray-700"
        >
          {/* <div className="flex justify-between mb-4"> */}
          {/* <div className="flex flex-col w-1/4 space-y-2 ">
              <label
                className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Approver Name <span className="text-red-500">*</span>
              </label>
              <select
                value={approverValue ?? ""}
                disabled={formRole === "ManageInput"}
                className="block p-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => { handleApproverInputChange('q' + mainIndexId, mainIndexId, "approver_id", e.target.value); }} // Example onChange
              >
                <option value="">Select Approver</option>
                {approverNameList?.map((item) => (
                  <option key={item.full_name} value={item.employee_id}>
                    {item.full_name}
                  </option>
                ))}
              </select>
              {approverError && <div className="text-red-500 text-sm mt-1">{approverError}</div>}
            </div> */}
          {copyQuarterName && copyButtonShowHide && (
            <div className="flex justify-end mb-3">
              <button
                className="inline-flex items-center px-3 capitalize  py-1 bg-blue-600 text-sm font-normal text-white border-0 border-blue-200 rounded-lg hover:bg-gray-100 hover:text-blue-600 "
                onClick={() => copyGoalsHandler(copyQuarterName, title)}
              >
                Copy {copyQuarterName} Goals
              </button>
            </div>
          )}
          {/* </div> */}
          {content}
        </div>
      )}
    </div>
  );
};

interface KPICellProps {
  item: Goals;
  quarterName: string;
  index: number;
  handleInputChange: (
    quarter: string,
    index: number,
    field: keyof Goals,
    value: string | number
  ) => void;
  formType: string;
  userRole: number | null;
  isQuarterApproved: boolean;
  isViewOnly?: boolean;
}

const KPICell: React.FC<KPICellProps> = ({
  item,
  quarterName,
  index,
  handleInputChange,
  formType,
  userRole,
  isQuarterApproved,
  isViewOnly = false,
}) => {
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();

  const baseTextRef = React.useRef(item.goal_description || "");
  const [isListeningLocal, setIsListeningLocal] = React.useState(false);
  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  // Auto-scroll to bottom when value changes
  React.useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [item.goal_description]);

  // Sync local state: if global listening stops, we stop too.
  React.useEffect(() => {
    if (!listening) {
      setIsListeningLocal(false);
    }
  }, [listening]);

  // push transcript live into KPI
  React.useEffect(() => {
    if (listening && isListeningLocal) {
      // console.log("Listening... Transcript:", transcript); 
      if (transcript) {
        const baseText = baseTextRef.current;
        const separator = baseText && baseText.trim().length > 0 ? " " : "";
        const newValue = baseText + separator + transcript;
        if (newValue !== item.goal_description) {
          handleInputChange(quarterName, index, "goal_description", newValue);
        }
      }
    } else if (!listening) {
        // Update base text ref when not listening, to capture manual edits
        if (item.goal_description) {
             baseTextRef.current = item.goal_description; 
        }
    }
  }, [transcript, listening, isListeningLocal, quarterName, index, handleInputChange, item.goal_description]);

  const isDisabled =
    isViewOnly ||
    isQuarterApproved ||
    [
      formType !== "ManageInput" && GoalsFlagStatusEnum.submit,
      GoalsFlagStatusEnum.approved,
      GoalsFlagStatusEnum.rejected,
    ].includes(Number(item.goal_status));

  const isReadOnly =
    isViewOnly ||
    (formType === "ManageInput" && USERROLEENUM.ADMIN !== userRole);

  return (
    <div className="relative">
      <textarea
        ref={textareaRef}
        disabled={isDisabled}
        rows={4}
        readOnly={isReadOnly}
        value={item.goal_description || ""}
        onChange={(e) =>
          handleInputChange(
            quarterName,
            index,
            "goal_description",
            e.target.value
          )
        }
        className="block p-2 pr-10 w-full text-sm text-gray-900 bg-white dark:bg-gray-700 dark:text-white border-0 focus:ring-0"
        placeholder=""
      />

      {/* 🎤 Toggle mic button */}
      {browserSupportsSpeechRecognition && !isDisabled && !isReadOnly && (
        <button
          type="button"
          onClick={() => {
            if (listening) {
              SpeechRecognition.stopListening();
            } else {
              // Capture current text as base before starting
              baseTextRef.current = item.goal_description || "";
              resetTranscript();
              setIsListeningLocal(true);
              SpeechRecognition.startListening({
                continuous: true,
                language: "en-IN",
              });
            }
          }}
          title="Dictate"
          className={`absolute top-2 right-5 p-1 rounded-full transition-all shadow-sm hover:shadow-md active:scale-95 cursor-pointer ${
            listening && isListeningLocal ? "bg-red-500 text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          {listening && isListeningLocal ? (
            <StopIcon className="w-4 h-4" />
          ) : (
            <MicrophoneIcon className="w-4 h-4" />
          )}
        </button>
      )}
    </div>
  );
};

export const GoalAccordion: React.FC<{
  data: GetEmployeeGoalDataResponse;
  // getQuatersList: DateRange[];
  getQuatersList: QuarterDates;
  routestate: string;
  formType: string;
  employeeID: number | null;
  startyear: string;
  assessmentStart: string;
  assessmentEnd: string;
  approverList: ApproverInterface[];
  isViewOnly?: boolean;
}> = ({
  data,
  getQuatersList,
  routestate,
  formType,
  employeeID,
  startyear,
  assessmentStart,
  assessmentEnd,
  approverList,
  isViewOnly = false,
}) => {

    const [approverValues, setApproverValues] = useState<string>("");
    const { addandupdateGoal, rejectGoal, approveEmployeeGoals, deleteGoal, GetIpmsEmployeeData } =
      useManageIPMSContext();
    const [quartersDataResponse, dispatch] = useReducer(
      quartersReducer,
      data?.quarters
    );
    const queryClient = useQueryClient();
    const [deletedQuarters, setDeletedQuarters] = useState<Goals[]>([]);
    const [validationErrors, setValidationErrors] = useState<
      Record<string, Record<number, string[]>>
    >({});
    const [weitageError, setWeitageError] = React.useState<{
      [key: string]: string;
    }>({});
    const navigate = useNavigate();
    const isAllAssessmentCompleted = useMemo(() => {
      return (
        data?.goal_assessment_status?.length > 0 &&
        data?.goal_assessment_status?.every(
          (item) =>
            item.assessment_status?.toUpperCase() ===
            GoalsAssessmentFlagStatusEnumTextCap.COMPLETED
        )
      );
    }, [data?.goal_assessment_status]);

    React.useEffect(() => {
      // console.log('data.quarters', data.quarters)
      if (data) {
        // console.log('data', data)
        setApproverValues(data?.approver_id ? String(data?.approver_id) : "");
        dispatch({
          type: "SET_QUARTERS",
          payload: Object.entries(data.quarters).reduce(
            (acc, [quarterName, quarterData]) => {
              const quarterKey = (quarterName.startsWith("q")
                ? quarterName
                : `q${quarterName}`) as keyof QuarterDates;

              if (!getQuatersList || !getQuatersList[quarterKey]) {
                return acc;
              }

              // quarterData is N1 (Quarters[key])
              const goalsList = quarterData.kra || [];

              const updatedGoals = goalsList.map((goal) => ({
                ...goal,
                target_date: goal.target_date || getQuatersList[quarterKey].end,
              }));

              return {
                ...acc,
                [quarterKey]: {
                  ...quarterData,
                  kra: updatedGoals,
                },
              };
            },
            {}
          ) as Quarters,
        });
      }
    }, [data, getQuatersList]);

    const employee_id = employeeID
      ? employeeID
      : Number(getUserIdTokenForIPMSEmployid());

    const addGoal = useCallback(
      (quarter: string, mainIndex: number) => {
        if (employee_id) {
          dispatch({
            type: "ADD_GOAL",
            quarter,
            goal: {
              id: null,
              target_date: getQuatersList[`q${mainIndex}` as keyof QuarterDates].end,
              weightage: 0,
              goal_status: "DRAFT", // Or default initial status
              goal_description: "",
              kra: "",
              // Add other mandatory fields from Goals if any
              changesType: "new",
              quater: mainIndex,
            },
          });
        }
      },
      [employee_id, getQuatersList]
    );

    const removeGoal = useCallback(
      (quarter: string, index: number) => {
        // quarter is string key of Quarters object (e.g., 'q1')
        const quarterData = quartersDataResponse[quarter];
        if (!quarterData || !quarterData.kra) return;

        const removedGoal = quarterData.kra.filter(
          (_, i) => i === index
        )[0];

        if (removedGoal && removedGoal.id !== null) {
          setDeletedQuarters((prevDeletedQuarters) => [
            ...prevDeletedQuarters,
            removedGoal,
          ]);
        }
        dispatch({ type: "REMOVE_GOAL", quarter, index });
      },
      [quartersDataResponse]
    );

    const handleInputChange = useCallback(
      (
        quarter: string,
        index: number,
        field: keyof Goals,
        value: string | number
      ) => {
        if (employee_id && field && quarter) {
          if (field === "weightage") {
            const weightageValue = Number(value);
            if (
              value !== null &&
              weightageValue !== 0 &&
              (isNaN(weightageValue) ||
                weightageValue < 1 ||
                weightageValue > 100)
            ) {
              return;
            }
          }

          dispatch({
            type: "UPDATE_GOAL",
            quarter,
            index,
            field,
            value,
          });

          setValidationErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };

            if (updatedErrors[quarter]?.[index]) {
              delete updatedErrors[quarter][index];
              if (Object.keys(updatedErrors[quarter]).length === 0) {
                delete updatedErrors[quarter];
              }
            }

            return updatedErrors;
          });
        }
      },
      [employee_id]
    );

    // const handleApproverChange = useCallback(
    //   (quarter: keyof QuartersResponse, index: number, field: string, value: string) => {
    //     if (employee_id && quarter) {
    //       // console.log(quarter, index, field, value)
    //       dispatch({
    //         type: "UPDATE_APPROVER",
    //         quarter,
    //         index,
    //         field: "approver_id", // Explicitly define the field
    //         value,
    //       });

    //       setValidationErrors((prevErrors) => {
    //         const updatedErrors = { ...prevErrors };

    //         if (updatedErrors[quarter]?.[index]) {
    //           delete updatedErrors[quarter][index];
    //           if (Object.keys(updatedErrors[quarter]).length === 0) {
    //             delete updatedErrors[quarter];
    //           }
    //         }

    //         return updatedErrors;
    //       });
    //     }
    //   },
    //   [employee_id],
    // );

    const CopyQuarterData = useCallback(
      (sourceQuarter: string, currentQuarter: string, mainIndex: number) => {
        const targetQuarterName = currentQuarter.toLowerCase();
        const sourceQuarterName = sourceQuarter.toLowerCase();

        if (quartersDataResponse && sourceQuarterName && targetQuarterName) {
          const sourceGoals = quartersDataResponse[sourceQuarterName];
          if (!sourceGoals || !sourceGoals.kra || sourceGoals.kra.length === 0) {
            return;
          }

          const quarterStartYear = Number(
            moment(
              getQuatersList[`q${mainIndex}` as keyof QuarterDates]?.start
            ).year()
          );
          const quarterEndYear =
            getQuatersList[`q${mainIndex}` as keyof QuarterDates].end ?? "";

          // Mark existing target quarter goals for deletion (grouped by quarter)
          const targetGoals =
            quartersDataResponse[targetQuarterName]?.kra || [];
          const deletableGoals = targetGoals
            .filter((g) => g.id !== null)
            .map((g) => ({
              ...g,
              quater: mainIndex, // ensure correct quarter id for delete grouping
            }));
          if (deletableGoals.length) {
            setDeletedQuarters((prev) => [...prev, ...deletableGoals]);
          }

          // Clone goals from the source quarter into target quarter
          const clonedGoals = (sourceGoals.kra || []).map((goal) => ({
            id: null,
            changesType: "new", // Assuming this is valid for Goals if extended
            quater: mainIndex,
            startyear: quarterStartYear,
            employeeid: employee_id,
            kra: goal.kra,
            target_date: quarterEndYear,
            weightage: goal.weightage,
            current: true, // check if current exists on Goals
            goal_status: "DRAFT", // defaulting to draft
            employeesubmitted: "",
            goal_description: goal.goal_description,
          }));

          // Replace target quarter goals with cloned goals
          dispatch({
            type: "CLONE_GOAL",
            quarter: targetQuarterName,
            goal: clonedGoals,
          });
        }
      },
      [quartersDataResponse, getQuatersList, employee_id]
    );

    const { user } = useAuth();
    const userRole = getCookieData("roleId")
      ? Number(getCookieData("roleId"))
      : user
        ? user.role_id
        : null;

    const renderQuarterItems = (
      quarterData: Goals[],
      quarterName: string,
      mainIndex: number,
      validationErrors: Record<string, Record<number, string[]>>,
      weightageError: { [key: string]: string }
    ) => {
      // Calculate the total weightage for the quarter
      const totalWeightage = quarterData.reduce(
        (sum, item) => sum + (item.weightage ?? 0),
        0
      );
      // console.log("==============>", getQuatersList, getQuatersList[mainIndex - 1]);
      // Guard against undefined values in getQuatersList
      // const quarterDateRange =
      //   getQuatersList && getQuatersList[`q${mainIndex}` as keyof QuarterDates]
      //     ? getQuatersList[`q${mainIndex}` as keyof QuarterDates]
      //     : { start: '', end: '' }; // Fallback to default value

      // Log for debugging purposes
      // console.log("Quarter Index:", mainIndex, "Date Range:", quarterDateRange);
      if (
        !getQuatersList ||
        !getQuatersList[`q${mainIndex}` as keyof QuarterDates]
      ) {
        console.warn(`Missing quarter data for q${mainIndex}`);
        return null;
      }

      const quarterDateRange = getQuatersList[
        `q${mainIndex}` as keyof QuarterDates
      ] ?? { start: "", end: "" };

      const quarterSubmitedStatus =
        quarterData &&
        Array.isArray(quarterData) &&
        quarterData.length > 0 &&
        quarterData[0].goal_status;

      const isQuarterApproved = data?.goal_assessment_status?.find(
        (item) => item.quarter_number === mainIndex
      )?.goal_status?.toUpperCase() === GoalsFlagStatusEnumTextCap.APPROVED;

      // console.log("quarterDateRange", quarterSubmitedStatus);
      return (
        <AccordionItem
          key={quarterName}
          title={String(quarterName).toUpperCase()}
          icon={<QuestionMarkCircleIcon className="w-5 h-5 me-2 shrink-0" />}
          dateRange={quarterDateRange as QuaterDate}
          copyQuarterName={
            formType !== "ManageInput"
              ? mainIndex === 1
                ? ""
                : mainIndex
                  ? "q" + String(mainIndex - 1)
                  : ""
              : ""
          }
          copyGoalsHandler={(data, currentQuarter) =>
            CopyQuarterData(data, currentQuarter, mainIndex)
          }
          copyButtonShowHide={
            isQuarterApproved ||
              (typeof quarterSubmitedStatus === "number" && // Check logic for goal_status
                [GoalsFlagStatusEnum.approved, GoalsFlagStatusEnum.rejected].includes(
                  Number(quarterSubmitedStatus) // Cast if goal_status is string "1"/"2"
                ))
              ? false
              : true
          }
          approverNameList={approverList ?? []}
          mainIndexId={mainIndex}
          approverError={
            validationErrors[quarterName]?.[0]?.includes(
              "Approver name is required."
            )
              ? "Approver name is required."
              : ""
          }
          // handleApproverInputChange={(quarter, index, field, value) =>
          //   handleApproverChange(quarter as keyof QuartersResponse, index, "approver_id", value)
          // }
          formRole={formType}
          // approverValue={quarterData[0]?.approver_id ?? ""}
          content={
            <div className="relative overflow-x-auto  ">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 z-5">
                <thead className="text-md sticky top-0 z-30 text-center text-gray-700 uppercase bg-green-200">
                  <tr>
                    <th scope="col" className="px-6 py-3 border-r">
                      SI
                    </th>
                    <th scope="col" className="px-6 py-3 border-r">
                      KRA<span className="text-red-400">*</span>
                    </th>
                    <th scope="col" className="px-6 py-3 border-r">
                      Measurable Goal/KPI (Key Performance Indicator)
                      <span className="text-red-400">*</span>
                    </th>
                    <th scope="col" className="px-6 py-3 border-r">
                      Weightage (in %)<span className="text-red-400">*</span>
                    </th>
                    <th scope="col" className="px-6 py-3 border-r">
                      Timeline<span className="text-red-400">*</span>
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(quarterData) &&
                    quarterData.map((item, index) => (
                      <tr
                        key={item.id ?? `goal-${index}`}
                        className="bg-white dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600"
                      >
                        <th
                          scope="row"
                          className="px-0 py-0 border-r text-center border-gray-200 dark:border-gray-600 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          {index + 1}
                        </th>
                        <td className="px-0 py-0 border-r border-gray-200 dark:border-gray-600">
                          <textarea
                            disabled={
                              isViewOnly ||
                              isQuarterApproved ||
                              [
                                formType !== "ManageInput" &&
                                GoalsFlagStatusEnum.submit,
                                GoalsFlagStatusEnum.approved,
                                GoalsFlagStatusEnum.rejected,
                              ].includes(Number(item.goal_status))
                            }
                            rows={4}
                            readOnly={
                              isViewOnly ||
                              (formType === "ManageInput" &&
                              USERROLEENUM.ADMIN !== userRole)
                            }
                            value={item.kra}
                            onChange={(e) =>
                              handleInputChange(
                                quarterName,
                                index,
                                "kra",
                                e.target.value
                              )
                            }
                            className="block p-2 w-full text-sm text-gray-900 bg-white dark:bg-gray-700 dark:text-white  border-0 ring-0"
                            placeholder=""
                          />
                          {validationErrors[quarterName]?.[index]?.includes(
                            "KRA is required."
                          ) && (
                              <p className="text-red-500 text-sm">
                                KRA is required.
                              </p>
                            )}
                            <SingleSelect
                            variant="kra"
                            isDisabled={
                              isViewOnly ||
                              isQuarterApproved ||
                              (formType === "ManageInput" &&
                                USERROLEENUM.ADMIN !== userRole) ||
                              [
                                formType !== "ManageInput" &&
                                GoalsFlagStatusEnum.submit,
                                GoalsFlagStatusEnum.approved,
                                GoalsFlagStatusEnum.rejected,
                              ].includes(Number(item.goal_status))
                            }
                            value={null} // Keep it null to act as a picker that resets
                            options={GetIpmsEmployeeData?.kra_options?.map((k: string) => ({
                              label: k,
                              value: k,
                            }))}
                            onChange={(option: any) => {
                              if (option) {
                                handleInputChange(
                                  quarterName,
                                  index,
                                  "kra",
                                  option.value
                                );
                              }
                            }}
                            placeholder="Select KRA"
                          />
                        </td>
                        <td className="px-0 py-0 border-r border-gray-200 dark:border-gray-600">
                          <KPICell
                            item={item}
                            quarterName={quarterName}
                            index={index}
                            handleInputChange={handleInputChange}
                            formType={formType}
                            userRole={userRole}
                            isQuarterApproved={isQuarterApproved ?? false}
                            isViewOnly={isViewOnly}
                          />
                          {validationErrors[quarterName]?.[index]?.includes(
                            "KPI is required."
                          ) && (
                              <p className="text-red-500 text-sm">
                                KPI is required.
                              </p>
                            )}
                        </td>
                        <td className="px-0 py-0 border-r text-center border-gray-200 dark:border-gray-600">
                          <textarea
                            disabled={
                              isViewOnly ||
                              isQuarterApproved ||
                              [
                                formType !== "ManageInput" &&
                                GoalsFlagStatusEnum.submit,
                                GoalsFlagStatusEnum.approved,
                                GoalsFlagStatusEnum.rejected,
                              ].includes(Number(item.goal_status))
                            }
                            rows={4}
                            readOnly={
                              isViewOnly ||
                              (formType === "ManageInput" &&
                              USERROLEENUM.ADMIN !== userRole)
                            }
                            value={
                              item.weightage === 0
                                ? ""
                                : String(item.weightage ?? "")
                            }
                            onChange={(e) =>
                              handleInputChange(
                                quarterName,
                                index,
                                "weightage",
                                Number(e.target.value)
                              )
                            }
                            className="block p-2 w-full h-full text-sm text-center text-gray-900 bg-white dark:bg-gray-700 dark:text-white  border-0"
                            placeholder=""
                          />
                          {validationErrors[quarterName]?.[index]?.includes(
                            "Weightage must be between 1 and 100."
                          ) && (
                              <p className="text-red-500 text-sm">
                                Weightage must be between 1 and 100.
                              </p>
                            )}
                        </td>
                        <td className="px-2 border-r border-gray-200 dark:border-gray-600 text-center mt-0">
                          <DatePicker
                            selected={
                              item.target_date
                                ? moment(item.target_date).toDate()
                                : null
                            } // Default to current date if item.goaltimeline is not set
                            onChange={(date) =>
                              handleInputChange(
                                quarterName,
                                index,
                                "target_date",
                                moment(date).format("YYYY-MM-DD")
                              )
                            }
                            // value={item.goaltimeline ? moment(item.goaltimeline).toDate() : moment(getQuatersList[mainIndex - 1].end).toDate() ??}
                            className="border border-gray-200 dark:border-gray-600 px-3 py-1 m-0 z-10"
                            minDate={moment(
                              getQuatersList[
                                `q${mainIndex}` as keyof QuarterDates
                              ].start
                            ).toDate()}
                            readOnly={
                              isViewOnly ||
                              (formType === "ManageInput" &&
                              USERROLEENUM.ADMIN !== userRole)
                            }
                            maxDate={moment(
                              getQuatersList[
                                `q${mainIndex}` as keyof QuarterDates
                              ].end
                            ).toDate()}
                            disabled={
                              isViewOnly ||
                              isQuarterApproved ||
                              [
                                formType !== "ManageInput" &&
                                GoalsFlagStatusEnum.submit,
                                GoalsFlagStatusEnum.approved,
                                GoalsFlagStatusEnum.rejected,
                              ].includes(Number(item.goal_status))
                            }
                            dateFormat="yyyy/MM/dd"
                            popperClassName="custom-datepicker-popper !z-[9999]"
                          />
                          {/* <select
                          disabled={[
                            formType !== "ManageInput" && GoalsFlagStatusEnum.submit,
                            GoalsFlagStatusEnum.approved,
                            GoalsFlagStatusEnum.rejected,
                          ].includes(item.submissionstatus)}
                          value={
                            item.goaltimeline ||
                            generateMonthArray(
                              moment(getQuatersList[mainIndex - 1].start).toDate(),
                              moment(getQuatersList[mainIndex - 1].end).toDate(),
                            )[2].value
                          } // Default to last month if no value set
                          className='block px-3 py-2 w-full  text-sm bg-white border dark:border-gray-600 dark:bg-gray-700 dark:text-white text-black rounded-lg '
                          onChange={(e) =>
                            handleInputChange(quarterName, index, "goaltimeline", e.target.value)
                          }
                        >
                         
                          {generateMonthArray(
                            moment(getQuatersList[mainIndex - 1].start).toDate(),
                            moment(getQuatersList[mainIndex - 1].end).toDate(),
                          )
                            .slice(0, 3)
                            .map((item) => (
                              <option key={item.label} value={item.value}>
                                {item.value}
                              </option>
                            ))}
                        </select> */}
                          {/* <input
                      type='month'
                      value={moment(item.goaltimeline).format("YYYY-MM")}
                      onChange={(e) =>
                        handleInputChange(quarterName, index, "goaltimeline", e.target.value)
                      }
                      className='block p-2 w-full text-sm text-center align-middle text-gray-900 bg-white rounded-lg border-0 border-white'
                    /> */}
                          {validationErrors[quarterName]?.[index]?.includes(
                            "Timeline is required."
                          ) && (
                              <p className="text-red-500 text-sm">
                                Timeline is required.
                              </p>
                            )}
                        </td>
                        <td className="px-6 py-4">
                          {index !== 0 &&
                            !isViewOnly &&
                            !isQuarterApproved &&
                            ![
                              formType !== "ManageInput" &&
                              GoalsFlagStatusEnum.submit,
                              GoalsFlagStatusEnum.approved,
                              GoalsFlagStatusEnum.rejected,
                            ].includes(Number(item.goal_status)) && (
                              <button
                                onClick={() => removeGoal(quarterName, index)}
                                className="font-medium text-red-600 hover:underline"
                              >
                                Remove
                              </button>
                            )}
                        </td>
                      </tr>
                    ))}
                </tbody>
                <tfoot className="bg-gray-100 dark:bg-gray-700 dark:text-white py-10 text-gray-900">
                  <tr>
                    <td className="px-2 py-2 font-medium text-md text-center"></td>
                    <td className="px-2 py-2 font-medium text-md text-center"></td>
                    <td className="px-2 py-2 font-medium text-md text-center">
                      Total Weightage (should not exceed 100%)
                    </td>
                    <td className="px-2 py-2 font-medium text-md text-center">
                      {/* {JSON.stringify(weightageError)} */}
                      {weightageError[quarterName] ? (
                        <span className="text-red-500 w-[100px]">
                          {weightageError[quarterName]}
                          {/* Total weightage for {String(quarterName).toUpperCase()} exceeds 100%. */}
                          <br /> Please adjust the values.
                        </span>
                      ) : (
                        totalWeightage
                      )}
                      {/* {totalWeightage > 100 ? (
            <span className='text-red-500'>
              Total weightage for {String(quarterName).toUpperCase()} exceeds 100%.
              <br /> Please adjust the values.
            </span>
          ) : (
            totalWeightage
          )} */}
                    </td>
                    <td className="px-2 py-2 font-medium text-md text-center"></td>
                    <td className="px-2 py-2 font-medium text-md ">
                      {!isViewOnly && !isQuarterApproved &&
                        ![
                          formType !== "ManageInput" && GoalsFlagStatusEnum.submit,
                          GoalsFlagStatusEnum.approved,
                          GoalsFlagStatusEnum.rejected,
                        ].includes(Number(quarterSubmitedStatus)) && (
                          <button
                            onClick={() => addGoal(quarterName, mainIndex)}
                            className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                          >
                            Add Goal
                          </button>
                        )}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          }
          isOpen={true}
        />
      );
    };

    // console.log('getQuatersList', getQuatersList)

    const ipmsID = employeeID ? employeeID : getUserIdTokenForIPMSEmployid();
    const softGoalsData = GetIpmsEmployeeData?.quarters?.['1']?.soft;
    const orgGoalsData = GetIpmsEmployeeData?.quarters?.['1']?.org;
    const isNewFlag = GetIpmsEmployeeData?.isNew;

    // console.log(softGoalsData, orgGoalsData, isNewFlag, "softGoalsData")
    // const StartYEAR = getQuatersList ? getQuatersList[`q1`]?.start : '';

    // const startYearValue = Number(moment(getQuatersList[`q1`]?.start).year());
    // console.log("newQuarters ===> ", startYearValue, getQuatersList);


    const handleSubmit = useCallback(
      async (
        status: number,
        quartersDataResponseData: Quarters,
        deleteIds: Goals[],
        quarterDataroutestate: string,
        approverDate: string,
        startYear: number,
        softGoalsData: any[],
        orgGoalsData: any[],
        isNewFlag: boolean,
      ) => {

        // console.log('quartersDataResponseData', quartersDataResponseData)
        // Validate total weightage
        if (quartersDataResponseData && status && ipmsID) {
          const validationErrors: Record<string, Record<number, string[]>> = {};
          const weightageErrors: { [key: string]: string } = {};

          // Validation for approver's name across all quarters
          // Object.keys(quartersDataResponseData).forEach((quarterName) => {
          //   const quarterGoals = quartersDataResponseData[quarterName as keyof QuartersResponse];
          //   quarterGoals.forEach((goal) => {
          //     if (!goal.approver_id || goal.approver_id === '') {
          //       setApproverError('Approver name is required');
          //     }
          //   });
          // });

          Object.keys(quartersDataResponseData).forEach((quarterName) => {
            const quarterData =
              quartersDataResponseData[quarterName as keyof Quarters];

            // Initialize error storage for each quarter
            validationErrors[quarterName] = {};

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            let totalWeightage: number = 0;

            // Validate individual fields
            (quarterData.kra || []).forEach((item, index) => {
              const fieldErrors: string[] = [];

              if (!item.kra) {
                fieldErrors.push("KRA is required.");
              }
              if (!item.goal_description) {
                fieldErrors.push("KPI is required.");
              }
              // if (!item.approver_id || item.approver_id === '') {
              //   fieldErrors.push("Approver name is required.");
              // }
              if (
                item.weightage === undefined ||
                item.weightage === null ||
                item.weightage < 1 ||
                item.weightage > 100
              ) {
                fieldErrors.push("Weightage must be between 1 and 100.");
              } else {
                totalWeightage += item.weightage; // Accumulate the weightage
              }

              if (!item.target_date) {
                fieldErrors.push("Timeline is required.");
              }
              if (fieldErrors.length > 0) {
                validationErrors[quarterName][index] = fieldErrors;
              }
            });
            // Check if total weightage for the quarter is 100
            // console.log("totalWeightage", totalWeightage, quarterName);
            if (totalWeightage !== 100) {
              // console.log("Weightage is not 100, updating error state for", quarterName);
              weightageErrors[quarterName] = `Total weightage for ${String(
                quarterName
              ).toUpperCase()} must be exactly 100%.`;
            }
          });

          // console.log("totalWeightage", weitageError);

          // Check if all quarters have empty error objects
          const allErrorsEmpty = Object.values(validationErrors).every(
            (errors) => Object.keys(errors).length === 0
          );

          const allweightageErrorsEmpty = Object.values(weightageErrors).every(
            (errors) => Object.keys(errors).length === 0
          );

          // if (!allErrorsEmpty || !allweightageErrorsEmpty) {
          //   toast.error("Unable to save. Please check all required fields.");
          // }

          // If there are validation errors and not all errors are empty, set them and return to prevent submission
          if (!allErrorsEmpty) {
            setValidationErrors(validationErrors);
            toast.error("Unable to save. Please check all required fields.");
            return; // Prevent submission
          }
          // console.log(allweightageErrorsEmpty, "allweightageErrorsEmpty", weitageError);
          if (!allweightageErrorsEmpty) {
            setWeitageError(weightageErrors);
            toast.error("Unable to save. Please check all required fields.");
            return; // Prevent submission
          }

          // console.log("submit approverValues", approverDate);

          if (!approverDate || approverDate === "") {
            toast.error("Unable to save. Approver Name is required");
            return;
          }

          // console.log(allweightageErrorsEmpty, "final", weightageErrors);
          setWeitageError({});
          setValidationErrors({}); // Clear any previous errors
          // console.log("payloadData list 3 ", quartersDataResponseData, deleteIds);

          // console.log(isNew, softGoalsData, orgGoalsData, "isNew")
          // console.log(isNew, "isNew")
          const payloadData = convertSaveUpdateGoalsToPayload(
            isNewFlag as boolean,
            softGoalsData,
            orgGoalsData,
            status,
            startYear,
            Number(ipmsID),
            quartersDataResponseData,
            deleteIds,
            assessmentStart,
            assessmentEnd,
            quarterDataroutestate,
            approverDate,
            // false
          );
          // console.log(payloadData, "payloadData");
          // console.log("payloadData ===> 4", payloadData);
          setDeletedQuarters([]);
          await addandupdateGoal(payloadData);
          queryClient.invalidateQueries({
            queryKey: ["employeeGoalsData", ipmsID],
          });
          // setNewQuartersData({});
        }
      },
      []
    );

    const deleteGoals = useCallback(async (employeeId: number, year: number) => {
      if (employeeId && year) {
        const payload = {
          employee_id: employeeId,
          assessment_year: year,
        };
        let confirmed = false;
        toast(
          ({ closeToast }) => (
            <ConfirmRejectToast
              title={'Are you sure you want to delete this employee goals?'}
              onConfirm={() => {
                confirmed = true;
                closeToast();
              }}
              onCancel={() => {
                confirmed = false;
                closeToast();
              }}
            />
          ),
          {
            closeButton: false,
            className:
              "p-0 w-[400px] border border-red-500/40 rounded-md shadow-md",
            autoClose: false,
            position: "top-center",
            onClose: async () => {
              if (confirmed) {
                try {
                  await deleteGoal(payload);
                } catch (error) {
                  toast.error("Failed to delete goals. Please try again.");
                }
              } else {
                toast.info("Deletion cancelled.");
              }
            },
          }
        );
      }
    }, [deleteGoal]);

    const rejectGoals = useCallback(async (employeeId: number) => {
      // const data = state?.id && state?.id.toString();
      if (employeeId) {
        // let idArray;
        // const quarter = routestate.split("q")[1];
        // Check if there is a comma, and split accordingly
        // if (data.trim().includes(",")) {
        //   idArray = data
        //     .split(",") // Split by comma
        //     .filter((id) => id.trim() !== "") // Remove empty values
        //     .map((id) => Number(id.trim())); // Convert to numbers
        // } else {
        //   idArray = [Number(data.trim())]; // Handle single ID case
        // }
        const payload = {
          employee_id: employeeId,
          assessment_year: GetIpmsEmployeeData?.assessment_year,
          status: GoalsFlagStatusEnumTextCap.DRAFT,
        };
        let confirmed = false;
        toast(
          ({ closeToast }) => (
            <ConfirmRejectToast
              title={'Are you sure you want to reject this employee goals?'}
              onConfirm={() => {
                confirmed = true;
                closeToast();
              }}
              onCancel={() => {
                confirmed = false;
                closeToast();
              }}
            />
          ),
          {
            closeButton: false,
            className:
              "p-0 w-[400px] border border-red-500/40 rounded-md shadow-md",
            autoClose: false,
            position: "top-center",
            onClose: async () => {
              if (confirmed) {
                try {
                  await rejectGoal(payload);
                  // toast.success("Assessment rejected successfully!");
                } catch (error) {
                  toast.error(
                    "Failed to reject goals. Please try again."
                  );
                }
              } else {
                toast.info("Rejection cancelled.");
              }
            },
          }
        );

      }
    }, []);

    const approveGoals = useCallback(async (employeeId: number, year: number) => {
      // const data = state?.id && state?.id.toString();
      console.log(year)
      if (employeeId) {
        // let idArray;
        // const quarter = routestate.split("q")[1];
        // Check if there is a comma, and split accordingly
        // if (data.trim().includes(",")) {
        //   idArray = data
        //     .split(",") // Split by comma
        //     .filter((id) => id.trim() !== "") // Remove empty values
        //     .map((id) => Number(id.trim())); // Convert to numbers
        // } else {
        //   idArray = [Number(data.trim())]; // Handle single ID case
        // }
        const payload = {
          employee_id: employeeId,
          assessment_year: GetIpmsEmployeeData?.assessment_year,
          // quaters: quarter ? [Number(quarter)] : [],
          status: GoalsFlagStatusEnumTextCap.APPROVED,
        };
        await approveEmployeeGoals(payload);
      }
    }, []);

    // const currentStatus = (quartersDataResponse['q1']?.status || "").toString().toUpperCase();
    const currentStatus = useMemo(() => {
      const targetQuarter = routestate || "q1";
      const qNum = parseInt(targetQuarter.replace("q", ""));
      const apiStatus = data?.goal_assessment_status?.find(
        (item) => item.quarter_number === qNum
      )?.goal_status;
      return (apiStatus || quartersDataResponse[targetQuarter]?.status || "")
        .toString()
        .toUpperCase();
    }, [routestate, data?.goal_assessment_status, quartersDataResponse]);


    return (
      <div id="accordion-open" data-accordion="open">
        {routestate
          ? Object.entries(quartersDataResponse).map(
            ([quarterName, quarterData], index) =>
              quarterName === routestate &&
              renderQuarterItems(
                quarterData?.kra || [],
                quarterName,
                index + 1,
                validationErrors,
                weitageError
              )
          )
          : Object.entries(quartersDataResponse).map(
            ([quarterName, quarterData], index) =>
              renderQuarterItems(
                quarterData?.kra || [],
                quarterName,
                index + 1,
                validationErrors,
                weitageError
              )
          )}
        <div className="flex flex-col w-1/4 space-y-2 ">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Approver Name <span className="text-red-500">*</span>
          </label>
          <select
            value={approverValues ?? ""}
            disabled={
              isViewOnly ||
              (formType === "ManageInput" && USERROLEENUM.ADMIN === userRole)
            }
            className="block p-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={(e) => setApproverValues(e.target.value)} // Example onChange
          >
            <option value="">Select Approver</option>
            {Array.isArray(approverList) && approverList.map((item: any) => (
              <option key={item.employee_id} value={String(item.employee_id)}>
                {item.full_name || item.employee_name || "Unknown"}
              </option>
            ))}
          </select>
        </div>
        {!isViewOnly && (
          <div className="py-10 text-right">
            {formType === "ManageInput" && [GoalsFlagStatusEnumTextCap.SUBMITTED].includes(currentStatus) && (
              <button
                onClick={() =>
                  approveGoals(employeeID as number, moment(startyear).year())
                }
                className="inline-flex items-center px-4 capitalize  mr-2 py-2 bg-blue-600 text-sm font-medium text-white border-0 border-blue-200 rounded-lg hover:bg-gray-100 hover:text-blue-600 "
              >
                Approve
              </button>
            )}

            {formType !== "ManageInput" &&
              ![
                GoalsFlagStatusEnumTextCap.APPROVED
              ].includes(currentStatus) && (
                <button
                  onClick={() =>
                    handleSubmit(
                      GoalsFlagStatusEnum.save,
                      quartersDataResponse,
                      deletedQuarters,
                      "",
                      approverValues,
                      moment(
                        getQuatersList[`q${1}` as keyof QuarterDates]?.start
                      ).year(),
                      softGoalsData || [],
                      orgGoalsData || [],
                      isNewFlag as boolean
                    )
                  }
                  className="inline-flex items-center px-4  mr-2 py-2 bg-black text-sm font-medium text-white border-0  rounded-lg hover:bg-gray-100 hover:text-black"
                >
                  Save
                </button>
              )}

            {formType === "ManageInput" &&
              (userRole === USERROLEENUM.ADMIN || userRole === USERROLEENUM.HR) &&
              !isAllAssessmentCompleted && (
                <button
                  onClick={() =>
                    deleteGoals(employeeID as number, moment(startyear).year())
                  }
                  className="inline-flex items-center px-4  mr-2 py-2 bg-red-600 text-sm font-medium text-white border-0  rounded-lg hover:bg-gray-100 hover:text-black"
                >
                  Delete
                </button>
              )}


            {formType === "ManageInput" &&
              !isAllAssessmentCompleted &&
              (
                <button
                  onClick={() =>
                    rejectGoals(employeeID as number)
                  }
                  className="inline-flex items-center px-4  mr-2 py-2 bg-red-600 text-sm font-medium text-white border-0  rounded-lg hover:bg-gray-100 hover:text-black"
                >
                  Reject
                </button>
              )}

            {formType !== "ManageInput" &&
              ![
                GoalsFlagStatusEnumTextCap.SUBMITTED,
                GoalsFlagStatusEnumTextCap.APPROVED,
                GoalsFlagStatusEnumTextCap.REJECTED,
              ].includes(currentStatus) && (
                <button
                  onClick={() =>
                    handleSubmit(
                      GoalsFlagStatusEnum.submit,
                      quartersDataResponse,
                      deletedQuarters,
                      "",
                      approverValues,
                      moment(
                        getQuatersList[`q${1}` as keyof QuarterDates]?.start
                      ).year(),
                      softGoalsData || [],
                      orgGoalsData || [],
                      isNewFlag as boolean
                    )
                  }
                  className="inline-flex items-center px-4  mr-2 py-2 bg-black text-sm font-medium text-white border-0  rounded-lg hover:bg-gray-100 hover:text-black"
                >
                  Submit
                </button>
              )}

            {formType === "ManageInput" &&
              USERROLEENUM.ADMIN !== userRole &&
              ![
                GoalsFlagStatusEnumTextCap.SUBMITTED,
                GoalsFlagStatusEnumTextCap.APPROVED,
                GoalsFlagStatusEnumTextCap.REJECTED,
              ].includes(currentStatus) && (
                <button
                  onClick={() =>
                    handleSubmit(
                      GoalsFlagStatusEnum.submit,
                      quartersDataResponse,
                      deletedQuarters,
                      "",
                      approverValues,
                      moment(
                        getQuatersList[`q${1}` as keyof QuarterDates]?.start
                      ).year(),
                      softGoalsData || [],
                      orgGoalsData || [],
                      isNewFlag as boolean
                    )
                  }
                  className="inline-flex items-center px-4  mr-2 py-2 bg-black text-sm font-medium text-white border-0  rounded-lg hover:bg-gray-100 hover:text-black"
                >
                  Submit
                </button>
              )}

            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center px-4  mr-2 py-2 bg-red-600 text-sm font-medium text-white border-0  rounded-lg hover:bg-gray-100 hover:text-red-600"
            >
              Close
            </button>
          </div>
        )}
      </div>
    );
  };

const GoalPage: React.FC = () => {
  const location = useLocation();
  const routestate = location.state as {
    start: string;
    end: string;
    quarterName: string;
    employeeID: number;
    formType: string;
    employeeName: string;
    dojStart?: string;
    dojEnd?: string;
  };
  const {
    GetEmployeeGoal,
    TSApproverList,
    employeeassessmentData,
  } = useManageIPMSContext();

  const calculatedQuarters = React.useMemo(() => {
    const startDate = routestate?.dojStart || routestate?.start;
    const endDate = routestate?.dojEnd || routestate?.end;

    if (startDate && endDate) {
      const start = moment(startDate);
      const end = moment(endDate);
      const ranges = getQuarterRanges(start, end);

      const quarterList: any = {};
      ranges.forEach((r, i) => {
        quarterList[`q${i + 1}`] = {
          start: r.start?.format("YYYY-MM-DD") || "",
          end: r.end?.format("YYYY-MM-DD") || "",
        };
      });
      return quarterList;
    }
    return employeeassessmentData;
  }, [routestate?.start, routestate?.end, routestate?.dojStart, routestate?.dojEnd, employeeassessmentData]);
  const ipmsID = getUserIdTokenForIPMSEmployid();


  const { data: employeeAssessmentData } = useQuery({
    queryKey: ["employeeGoalsData", routestate?.start, ipmsID],
    queryFn: async () => {
      if (routestate?.start && ipmsID) {
        const payload = {
          employee_id:
            routestate?.formType === "ManageInput"
              ? routestate.employeeID
              : Number(ipmsID),
          start_assessment_date: routestate.start,
        };
        const response: any = await GetEmployeeGoal(payload);
        // console.log('response', response)
        // setEmployeeAssessmentData(response?.quarterList as QuarterDates);
        return response;
      }
      return null;
    },
    enabled: !!routestate?.start && !!ipmsID,
  });

  // console.log('employeeAssessmentData', employeeAssessmentData)

  // const fetchTSApprover = useCallback(async () => {
  //   if (routestate?.start && ipmsID) {
  //     const payload = {
  //       employee_id:
  //         routestate?.formType === "ManageInput"
  //           ? routestate.employeeID
  //           : Number(ipmsID),
  //     };
  //     try {
  //       const response = await getEmployeeTSApproverList(payload);
  //       // Handle the response
  //       // dispatch({ type: "SET_EMPLOYEE_DATA", payload: response });
  //       // console.log("ww", response);
  //       return response;
  //     } catch (error) {
  //       // Handle any errors
  //       console.error("Error fetching employee goal:", error);
  //     }
  //   }
  // }, [routestate?.start, ipmsID, GetEmployeeGoal]);

  // Assuming state is an object with an 'id' property

  // const fetchEmployeeGoal = useCallback(async () => {
  //   if (routestate?.start && ipmsID) {
  //     const payload = {
  //       employee_id:
  //         routestate?.formType === "ManageInput"
  //           ? routestate.employeeID
  //           : Number(ipmsID),
  //       start_assessment_date: routestate.start,
  //     };
  //     try {
  //       const response: any = await GetEmployeeGoal(payload);
  //       // Handle the response
  //       // dispatch({ type: "SET_EMPLOYEE_DATA", payload: response });
  //       // console.log("ww", response);
  //       // setCheckQuaterResponse(response ? true : false)
  //       setEmployeeAssessmentData(response?.quarterList as QuarterDates);
  //       fetchTSApprover();
  //       return response;
  //     } catch (error) {
  //       // Handle any errors
  //       console.error("Error fetching employee goal:", error);
  //     }
  //   }
  // }, [routestate?.start, ipmsID, GetEmployeeGoal]);

  // React.useEffect(() => {
  //   fetchEmployeeGoal();
  // }, [fetchEmployeeGoal]);

  // const getQuaters = getQuarterRanges(moment(routestate?.start), moment(routestate?.end));

  // console.log('getQuaters', getQuaters)
  // const getQuaters = employeeassessmentData?.map((item) => {
  //   return {
  //     start: item.start_date,
  //     end: item.end_date,
  //   };
  // }) ?? []

  // console.log('checkQuaterResponse', checkQuaterResponse);

  // console.log("EmployeeAssessmentData ===>", EmployeeAssessmentData);
  const renderGoals = React.useMemo(() => {
    return (
      employeeAssessmentData &&
      routestate && (
        <GoalAccordion
          data={employeeAssessmentData as unknown as GetEmployeeGoalDataResponse}
          getQuatersList={calculatedQuarters as QuarterDates}
          assessmentStart={routestate?.start}
          assessmentEnd={routestate?.end}
          routestate={""}
          formType={routestate?.formType}
          startyear={routestate?.start}
          employeeID={
            routestate?.formType === "ManageInput"
              ? routestate.employeeID
              : null
          }
          approverList={TSApproverList ?? []}
        />
      )
    );
  }, [routestate, employeeAssessmentData, employeeassessmentData, TSApproverList]);

  return (
    <div className="container mx-auto">
      {routestate && routestate?.formType !== "ManageInput" && (
        <GoalsAccordianPage />
      )}
      {routestate.employeeID && (
        <p className="pb-5 text-sm font-semibold text-gray-800">
          Employee ID: {routestate.employeeID}, Employee Name:{" "}
          {routestate.employeeName}
        </p>
      )}

      <p className="pb-5 textmdm font-semibold text-gray-800">
        Assessment Period:{" "}
        {moment(routestate?.dojStart || routestate?.start).isValid() &&
          moment(routestate?.dojStart || routestate?.start).format("DD/MM/YYYY")}{" "}
        -{" "}
        {moment(routestate?.dojEnd || routestate?.end).isValid() &&
          moment(routestate?.dojEnd || routestate?.end).format("DD/MM/YYYY")}
      </p>
      {renderGoals}
    </div>
  );
};

export default GoalPage;


